import {
    ADD_FAVOURITE_ORG,
    FETCH_ALL_ORG_SUCCESS,
    FETCH_ORG_SUCCESS,
    FILTER_ORG,
    GET_ALL_ORG,
    GET_UNSELECTED_ALL_ORG,
    HANDLE_ORG_REQUEST_CLOSE,
    HIDE_ORG_LOADER,
    SHOW_ORG_LOADER,
    ON_ADD_ORG,
    ON_ALL_ORG_SELECT,
    ON_ORG_CLOSE,
    ON_ORG_SELECT,
    ON_DELETE_ORG,
    ON_DELETE_SELECTED_ORG,
    ON_FILTER_ORG_OPTION_SELECT,
    ON_SAVE_ORG_SUCCESS,
    ON_TOGGLE_ORG_DRAWER,
    SHOW_ORG_MESSAGE,
    UPDATE_SEARCH_ORG,
    ON_EMP_DASHBOARD,
    ON_ORG_SURVEY_DASHBOARD,
    ON_ORG_DASHBOARD_SUCCESS,
    ON_PROJECT_DASHBOARD,
    ON_IMPERSONATE_DASHBOARD,
    ON_ORG_SURVEY_COMPARE_DASHBOARD,
    FETCH_ORG_STATISTICS_SUCCESS,
    CLEAR_SESSION,
    CLEAR_SELECTED_OBJECTS,
} from 'constants/ActionTypes';
import { addOrUpdateEntry } from 'services/arrayService';

export const INIT_STATE = {
    alertMessage: '',
    showMessage: false,
    loader: false,
    noContentFoundMessage: 'No organisations found in selected folder',
    selectedSectionId: 1,
    drawerState: false,
    filterOption: 'All orgs',
    allOrg: [],
    orgList: [],
    selectedOrg: null,
    selectedOrgs: 0,
    addOrgState: false,
    searchOrg: '',
    orgDashboardData: {},
    orgStatisticsData: {},
    org: {
        name: 'ACME Inc',
        email: 'road.runner@example.com',
        avatar: 'assets/images/organisation-150_150.jpg'
    },
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case CLEAR_SESSION: {
            return {
                ...INIT_STATE,
            };
        }
        case CLEAR_SELECTED_OBJECTS: {
            return {
                ...state,
                selectedOrg: null,
            };
        }
        case FETCH_ORG_STATISTICS_SUCCESS: {
            return {
                ...state,
                orgStatisticsData: action.payload,
            };
        }
        case ON_EMP_DASHBOARD: 
        case ON_PROJECT_DASHBOARD:
        case ON_IMPERSONATE_DASHBOARD:
        case ON_ORG_SURVEY_DASHBOARD:
        case ON_ORG_SURVEY_COMPARE_DASHBOARD: {
            return {
                ...state,
                loader: false,
                selectedOrg: action.payload,
                org: { ...state.org, name: action.payload ?. name },
            };
        }
        case ON_ORG_DASHBOARD_SUCCESS: {
            return {
                ...state,
                loader: false,
                orgDashboardData: action.payload,
            };
        }
        case ADD_FAVOURITE_ORG: {
            return {
                ...state,
                alertMessage: action.payload.starred ? 'Organisation removed as star' : 'Organisation marked as star',
                showMessage: true,
                orgList: state.orgList.map((org) => org.id === action.payload.id ? {
                    ...org,
                    starred: !action.payload.starred
                } : org),
                allOrg: state.allOrg.map((org) => org.id === action.payload.id ? {
                    ...org,
                    starred: !action.payload.starred
                } : org)
            };
        }
        case FETCH_ORG_SUCCESS: {
            return {
                ...state,
                loader: false,
                selectedOrg: action.payload,
                org: { ...state.org, name: action.payload ?. name },
            };
        }
        case FETCH_ALL_ORG_SUCCESS: {
            return {
                ...state,
                loader: false,
                allOrg: action.payload,
                orgList: action.payload,
            };
        }
        case SHOW_ORG_MESSAGE: {
            return {
                ...state,
                alertMessage: action.payload,
                showMessage: true,
                loader: false
            };
        }
        case ON_ORG_SELECT: {
            action.payload.selected = !action.payload.selected;
            let selectedOrgs = 0;
            const orgList = state.orgList.map(org => {
                if (org.selected) {
                    selectedOrgs++;
                }
                if (org.id === action.payload.id) {
                    if (org.selected) {
                        selectedOrgs++;
                    }
                    return action.payload;
                } else {
                    return org;
                }
            }
            );
            return {
                ...state, INIT_STATE,
                selectedOrgs: selectedOrgs,
                orgList: orgList
            };
        }
        case ON_ADD_ORG: {
            return { ...state, addOrgState: true };
        }
        case ON_ORG_CLOSE: {
            return { ...state, addOrgState: false };
        }
        case ON_FILTER_ORG_OPTION_SELECT: {
            let selectedSectionId = 0;
            let filterOption = '';
            let orgList = [];
            switch (action.payload.name) {
                case 'All organisations': {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    orgList = state.allOrg;
                    break;
                }
                case 'Frequently accessed': {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    orgList = state.allOrg.filter((org) => org.frequently);
                    break;
                }
                case 'Starred organisations': {
                    selectedSectionId = action.payload.id;
                    filterOption = action.payload.name;
                    orgList = state.allOrg.filter((org) => org.starred);
                    break;
                }
            }
            return {
                ...state, selectedSectionId, filterOption, orgList, drawerState: false
            };
        }
        case ON_SAVE_ORG_SUCCESS: {
            return {
                ...state,
                alertMessage: 'Organisation Updated Successfully',
                showMessage: true,
                orgList: addOrUpdateEntry(state.orgList, action.payload),
                allOrg: addOrUpdateEntry(state.allOrg, action.payload),
                loader: false,
            };
        }
        case ON_DELETE_ORG: {
            return {
                ...state,
                alertMessage: 'Organisation Deleted Successfully',
                showMessage: true,
                allOrg: state.allOrg.filter((org) => org.id !== action.payload.id),
                orgList: state.allOrg.filter((org) => org.id !== action.payload.id),
            };
        }
        case ON_DELETE_SELECTED_ORG: {
            const orgs = state.allOrg.filter((org) => !org.selected);
            return {
                ...state,
                alertMessage: 'Organisation Deleted Successfully',
                showMessage: true,
                allOrg: orgs,
                orgList: orgs,
                selectedOrgs: 0
            };
        }
        case FILTER_ORG: {
            const { filterOption } = state;
            let orgList = [];
            if (action.payload === '') {
                orgList = state.allOrg;
            } else {
                const filterOrganisation = state.allOrg.filter((org) =>
                    org.name.toLowerCase().indexOf(action.payload.toLowerCase()) > - 1);
                if (filterOption === 'All organisations') {
                    orgList = filterOrganisation;
                } else if (filterOption === 'Frequently accessed') {
                    orgList = filterOrganisation.filter((org) => org.frequently);
                } else if (filterOption === 'Starred organisations') {
                    orgList = filterOrganisation.filter((org) => org.starred);
                }
            }
            return { ...state, orgList: orgList };
        }
        case GET_ALL_ORG: {
            let orgList = state.allOrg.map((org) => org ? {
                ...org,
                selected: true
            } : org);
            return {
                ...state,
                selectedOrgs: orgList.length,
                allOrg: orgList,
                orgList: orgList
            };
        }
        case GET_UNSELECTED_ALL_ORG: {
            let orgList = state.allOrg.map((org) => org ? {
                ...org,
                selected: false
            } : org);
            return {
                ...state,
                selectedOrgs: 0,
                allOrg: orgList,
                orgList: orgList
            };
        }
        case ON_ALL_ORG_SELECT: {
            const selectAll = state.selectedOrgs < state.orgList.length;
            let selectedOrgs = 0;
            let orgList = [];
            if (selectAll) {
                orgList = state.allOrg.map((org) => org ? {
                    ...org,
                    selected: true
                } : org);
                selectedOrgs = orgList.length;
            } else {
                orgList = state.allOrg.map((org) => org ? {
                    ...org,
                    selected: true
                } : org);
                selectedOrgs = 0;
            }
            return {
                ...state,
                selectedOrgs: selectedOrgs,
                allOrg: orgList,
                orgList: orgList
            };
        }
        case UPDATE_SEARCH_ORG: {
            return { ...state, searchOrg: action.payload };
        }
        case HANDLE_ORG_REQUEST_CLOSE: {
            return { ...state, showMessage: false };
        }
        case ON_TOGGLE_ORG_DRAWER: {
            return { ...state, drawerState: !state.drawerState };
        }
        case SHOW_ORG_LOADER: {
            return { ...state, loader: true };
        }
        case HIDE_ORG_LOADER: {
            return { ...state, loader: false };
        }

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./reducers/Organisation.js